<template>
  <form
    @submit.prevent="submitUserRole"
    class="Scroll px-3 sm:px-6 py-3 w-full h-full border border-gray-400 rounded-md">
    <div class="flex flex-col w-full mb-3">
      <label class="mb-2 text-xs text-white">Nama Grup Pengguna</label>
      <input
        class="px-3 py-3 w-full h-8 form-input rounded-md text-xs"
        type="text"
        v-model="roleName">
    </div>
    <div class="flex flex-col w-full mb-3">
      <p class="pb-3 mb-1 text-xs text-white">Izin Akses</p>
      <table class="table-auto w-full">
        <colgroup>
          <col style="width: 5%;" />
          <col style="width: 35%;" />
          <col style="width: 60%;" />
        </colgroup>
        <tr
          v-for="permission of permissions.data"
          :key="permission.permission_id"
          class="border border-gray-400">
          <td class="text-center px-2 py-2">
            <input
              @change="selectPermission(permission, $event)"
              class="h-4 w-4 text-indigo-600 border-gray-300 rounded focus:ring-indigo-500"
              type="checkbox"
              :checked="isSelectedPermission(permission)">
          </td>
          <td class="text-left px-2 py-2 text-xs text-white">{{ permission.permission_name }}</td>
          <td class="text-left px-2 py-2 text-xs text-white">{{ permission.permission_description }}</td>
        </tr>
      </table>
    </div>
    <div class="flex flex-col w-full mb-3">
      <p class="pb-3 mb-1 text-xs text-white">WPP (wilayah pengelolaan perikanan yang dapat dimonitor)</p>
      <table class="table-auto w-full">
        <colgroup>
          <col style="width: 5%;" />
          <col style="width: 95%;" />
        </colgroup>
        <tr
          v-for="(item, itemIndex) of listWPP"
          :key="itemIndex"
          class="border border-gray-400">
          <td class="text-center px-2 py-2">
            <input
              @change="selectWPP(item)"
              :checked="isSelectedWPP(item.wpp_id)"
              class="h-4 w-4 text-indigo-600 border-gray-300 rounded focus:ring-indigo-500"
              type="checkbox">
          </td>
          <td class="text-left px-2 py-2 text-xs text-white">{{ item.wpp_name }}</td>
        </tr>
      </table>
    </div>
    <div class="flex flex-col w-full mb-3">
      <p class="pb-3 mb-1 text-xs text-white">Pelabuhan (pelabuhan pangkalan yang dapat dimonitor)</p>
      <div class="flex flex-col w-full mb-3">
        <input
          v-model="portSearch"
          class="px-3 py-3 w-full h-8 form-input rounded-md text-xs"
          type="text"
          placeholder="cari nama pelabuhan ...">
      </div>
      <table class="table-auto w-full">
        <colgroup>
          <col style="width: 5%;" />
          <col style="width: 95%;" />
        </colgroup>
        <tbody>
          <tr class="border bg-gray-300">
            <td class="text-center px-2 py-2">
              <input
                @change="selectPorts($event)"
                class="h-4 w-4 text-indigo-600 border-gray-300 rounded focus:ring-indigo-500"
                type="checkbox">
            </td>
            <td class="text-left px-2 py-2 text-xs text-slate">Pilih Semua</td>
            <td class="text-left px-2 py-2 text-xs text-slate">
              <button
                @click="toggle('pelabuhan')"
                type="button">
                <i class="material-icons text-stone-900">{{ display.pelabuhan ? 'expand_less' : 'expand_more' }}</i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
      <table
        v-if="display.pelabuhan">
        <colgroup>
          <col style="width: 5%;" />
          <col style="width: 95%;" />
        </colgroup>
        <tbody>
          <tr
            v-for="(port, portIndex) of settingPortsDefaultEnable"
            :key="portIndex"
            :class="`border border-gray-400 ${!portSearch || port.nama_pelab.toLowerCase().indexOf(portSearch.toLowerCase()) >= 0 ? '' : 'hidden'}`">
            <td class="text-center px-2 py-2">
              <input
                @change="selectPort(portIndex, port, $event)"
                checked="true"
                class="h-4 w-4 text-indigo-600 border-gray-300 rounded focus:ring-indigo-500"
                type="checkbox">
            </td>
            <td class="text-left px-2 py-2 text-xs text-white">{{ port.nama_pelab }}</td>
          </tr>
          <tr
            v-for="(port, portIndex) of settingPortsDefaultDisable"
            :key="portIndex"
            :class="`border border-gray-400 ${!portSearch || port.nama_pelab.toLowerCase().indexOf(portSearch.toLowerCase()) >= 0 ? '' : 'hidden'}`">
            <td class="text-center px-2 py-2">
              <input
                @change="selectPort(portIndex, port, $event)"
                class="h-4 w-4 text-indigo-600 border-gray-300 rounded focus:ring-indigo-500"
                type="checkbox">
            </td>
            <td class="text-left px-2 py-2 text-xs text-white">{{ port.nama_pelab }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="flex flex-col w-full mb-3">
      <p class="pb-3 mb-1 text-xs text-white">Kapal (kapal yang dapat dimonitor)</p>
      <div class="w-full mb-1">
        <div class="relative flex flex-row items-center w-full h-8 bg-white border border-gray-500 rounded-md">
          <span
            class="grow-1 w-full  z-0 px-3 text-xs text-gray-500"
            style="white-space: nowrap;overflow: hidden;">{{ file ? file.name : 'klik untuk pilih file' }}</span>
          <i class="material-icons flex z-0 justify-center items-center w-8 h-8 text-lg text-gray-500">upload_file</i>
          <input
            @change="selectFile($event)"
            class="absolute top-0 right-0 bottom-0 left-0 z-0 form-input w-full h-8 rounded-md text-xs opacity-0"
            type="file">
        </div>
      </div>
      <table class="table-auto w-full">
        <colgroup>
          <col style="width: 5%;" />
          <col style="width: 95%;" />
        </colgroup>
        <tbody>
          <tr class="border bg-gray-300">
            <td class="text-center px-2 py-2">
              <button
                @click="toggleKapals()"
                type="button">
                <i class="material-icons text-lg text-stone-900">{{roleKapalDeletedTotal > 0 ? 'add' : 'remove'}}</i>
              </button>
            </td>
            <td class="text-left px-2 py-2 text-xs text-slate">Hapus Semua</td>
            <td class="text-left px-2 py-2 text-xs text-slate">
              <button
                @click="toggle('kapal')"
                type="button">
                <i class="material-icons text-stone-900">{{ display.kapal ? 'expand_less' : 'expand_more' }}</i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
      <table
        v-if="display.kapal">
        <colgroup>
          <col style="width: 5%;" />
          <col style="width: 95%;" />
        </colgroup>
        <tbody>
          <tr
            v-for="(kapal, kapalIndex) of roleKapal"
            :key="kapalIndex"
            class="border border-gray-400">
            <td class="text-center px-2 py-2">
              <button
                @click="toggleKapal(kapalIndex)"
                type="button">
                <i class="material-icons text-lg text-stone-900">{{roleKapalDeleted[kapalIndex] ? 'add' : 'remove'}}</i>
              </button>
            </td>
            <td
              :class="`text-left px-2 py-2 text-xs ${roleKapalDeleted[kapalIndex] ? 'text-red-500' : 'text-white'}`">{{ kapal }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="flex flex-row justify-end">
      <button
        class="bg-green-500 px-2 py-2 rounded-md text-xs text-white"
        type="submit">Simpan</button>
    </div>
  </form>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import { read, utils } from 'xlsx'

export default {
  name: 'FormUserRole',
  props: {
    roleId: {
      type: Number,
      default: null
    }
  },
  data: () => ({
    roleName: null,
    rolePermissions: [],
    roleWPP: {},
    rolePorts: {},
    roleKapal: {},
    roleKapalDeleted: {},
    roleKapalDeletedTotal: 0,
    portSearch: null,
    display: {
      pelabuhan: false,
      kapal: false
    },
    file: null
  }),
  computed: {
    ...mapGetters([
      'message',
      "poi",
      'userRole',
      'permissions',
      'listWPP',
      'settingPortsDefault',
      'settingPortsActive'
    ]),
    settingPortsDefaultEnable: function () {
      const result = {}

      for (var portIndex in this.settingPortsDefault) {
        if (this.isSelectedPort(portIndex) === true) {
          result[portIndex] = this.settingPortsDefault[portIndex]
        }
      }

      return result
    },
    settingPortsDefaultDisable: function () {
      const result = {}

      for (var portIndex in this.settingPortsDefault) {
        if (this.isSelectedPort(portIndex) === false) {
          result[portIndex] = this.settingPortsDefault[portIndex]
        }
      }

      return result
    }
  },
  components: {
  },
  methods: {
    ...mapActions([
      'loadUserRole',
      'loadPermissions',
      'toLoadListWPP',
      'toLoadSettingPorts',
      'toAddUserRole',
      'addRolePermission',
      'deleteRolePermission',
      'editUserRole',
      'toUploadPorts'
    ]),
    ...mapMutations([
      'setMessage'
    ]),
    toggle: function (key) {
      this.display[key] = !this.display[key]
    },
    isSelectedPermission: function (permission) {
      for (var p of this.rolePermissions) {
        if (p.permission_id === permission.id) {
          return true
        }
      }

      return false
    },
    selectPermission: function (permission, e) {
      for (var index in this.rolePermissions) {
        if (this.rolePermissions[index].permission_id === permission.id) {
          if (!e.target.checked) {
            if (this.rolePermissions[index].type === 'new') {
              this.rolePermissions.splice(index, 1)
            } else {
              this.rolePermissions[index].type = 'remove'
            }
          } else if (this.rolePermissions[index].type === 'remove') {
            this.rolePermissions[index].type = 'cancel remove'
          }

          return
        }
      }

      permission.type = 'new'
      permission.permission_id = permission.id

      this.rolePermissions.push(permission)
    },
    selectWPP: function (wpp) {
      if (this.roleWPP[wpp.wpp_id]) {
        delete this.roleWPP[wpp.wpp_id]
      } else {
        this.roleWPP[wpp.wpp_id] = wpp.wpp_id
      }
    },
    isSelectedWPP: function (wppId) {console.log(this.roleWPP, wppId)
      if (typeof this.roleWPP[wppId] !== 'undefined') return true
      else return false
    },
    selectPorts: function (e) {
      for (var portIndex in this.settingPortsDefault) {
        let allowToCheck = false
        const port = this.settingPortsDefault[portIndex]

        if (this.portSearch) {
          if (port.nama_pelab.toLowerCase().indexOf(this.portSearch.toLowerCase()) >= 0) {
            allowToCheck = true
          }
        } else {
          allowToCheck = true
        }

        if (allowToCheck) {
          if (!e.target.checked) {
            delete this.rolePorts[portIndex]
          } else {
            if (port.id) {
              this.rolePorts[portIndex] = port.id
            }
          }
        }
      }
    },
    selectPort: function (portIndex, port) {
      if (this.rolePorts[portIndex]) {
        delete this.rolePorts[portIndex]
      } else {
        if (port.id) {
          this.rolePorts[portIndex] = port.id
        }
      }
    },
    isSelectedPort: function (index) {
      if (typeof this.settingPortsActive[index] !== 'undefined') return true
      else return false
    },
    selectFile: function (e) {
      this.file = e.target.files[0]

      const reader = new FileReader()

      reader.onload = this.parsingFile

      reader.readAsArrayBuffer(this.file)
    },
    parsingFile: function (e) {
      const data = new Uint8Array(e.target.result)
      const workbook = read(data, {
        type: 'array',
        cellDates: true
      })

      let errorStatus = false
      let errorMessage = ''

      for (var sheetName in workbook.Sheets) {
        const sheet = workbook.Sheets[sheetName]
        let rowCount = false

        if (typeof sheet['!ref'] !== 'undefined') {
          rowCount = utils.decode_range(sheet['!ref']).e.r
        }

        if (rowCount === false || rowCount < 1) {
          errorStatus = true
          errorMessage = 'File tidak memiliki data!'
        } else if (typeof sheet['A1'] === 'undefined') {
          errorStatus = true
          errorMessage = 'File tidak memiliki kolom TRANSMITER !'
        } else {
          const kapal = {}

          for (var key = 1; key <= rowCount; key++) {
            const row = key + 1

            if (typeof sheet[`A${row}`] === 'undefined') {
              if (key === rowCount) break;

              errorStatus = true
              errorMessage = 'Kolom TRANSMITER pada baris ke-' + row + ' masih kosong!'
              break;
            } else {
              kapal[key] = sheet[`A${row}`].v
            }
          }

          this.roleKapal = kapal
        }
      }

      if (errorStatus) {
        this.setMessage({
          text: errorMessage,
          status: 400
        })
      }
    },
    toggleKapals: function () {

      if (this.roleKapalDeletedTotal < 1) {
        for (var kapalIndex in this.roleKapal) {
          this.roleKapalDeleted[kapalIndex] = true
          this.roleKapalDeletedTotal += 1
        }
      } else {
        this.roleKapalDeleted = {}
        this.roleKapalDeletedTotal = 0
      }
    },
    toggleKapal: function (kapalIndex) {
      if (this.roleKapalDeleted[kapalIndex]) {
        delete this.roleKapalDeleted[kapalIndex]
        this.roleKapalDeletedTotal -= 1
      } else {
        this.roleKapalDeleted[kapalIndex] = true
        this.roleKapalDeletedTotal += 1
      }
    },
    submitUserRole: async function () {
      let roleId = null
      let wpp = {}
      let wppIndex = 0

      for (var wppId in this.roleWPP) {
        wpp[wppIndex] = wppId
        wppIndex += 1
      }

      if (wppIndex >= this.listWPP.length) {
        wpp[wppIndex] = '0'
      }

      wpp = JSON.stringify(wpp)

      let kapal = {}
      let kapalId = 0

      for (var kapalIndex in this.roleKapal) {
        if (typeof this.roleKapalDeleted[kapalIndex] === 'undefined') {
          kapal[kapalId] = this.roleKapal[kapalIndex]

          kapalId++
        }
      }

      kapal = JSON.stringify(kapal)

      if (typeof this.roleId === 'number') {
        roleId = this.roleId

        await this.editUserRole({
          id: this.roleId,
          name: this.roleName,
          wpp: wpp,
          kapal: kapal
        })
      } else {
        roleId = await this.toAddUserRole({
          name: this.roleName,
          wpp: wpp,
          kapal: kapal
        })
      }

      if (roleId) {
        for (var permission of this.rolePermissions) {
          if (permission.type === 'new') {
            await this.addRolePermission({
              role_id: roleId,
              permission_id: permission.id
            })
          } else if (permission.type === 'remove') {
            await this.deleteRolePermission(permission.id)
          }
        }

        await this.toUploadPorts({
          id: roleId,
          ports: JSON.stringify(this.rolePorts)
        })
      }
    }
  },
  created: async function () {
    await this.loadPermissions()
    await this.toLoadListWPP()
    await this.toLoadSettingPorts({
      role_id: this.roleId,
      with_default: true
    })

    if (typeof this.roleId === 'number') {
      await this.loadUserRole(this.roleId)

      this.roleName = this.userRole.role.role_name
      this.rolePermissions = this.userRole.permissions
      this.rolePorts = this.settingPortsActive
      this.roleKapal = this.userRole.preset.kapal

      let wpp = {}

      for (var wppIndex in this.userRole.preset.wpp) {
        const wppId = this.userRole.preset.wpp[wppIndex]

        wpp[wppId] = wppId
      }

      this.roleWPP = wpp
    }
  }
}
</script>
